import React from "react"
import { graphql } from "gatsby"
import Layout from "../../components/layout"

const IndexPage = ({ data }) => {
  const imgData = data.fileName.childImageSharp.fluid
  const author = "suga"
  const quote = `Life is tough, and things don't always work out well, but we should be brave and go on with our lives.`

  return <Layout imgData={imgData} author={author} quote={quote} />
}

export default IndexPage

export const query = graphql`
  query {
    fileName: file(relativePath: { eq: "suga1.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`
